export const LOADER_STATUS = "boilerplate/ImsReco/View/LOADER_STATUS";
export const SUMMARY_TABLE_DATA = "boilerplate/ImsReco/View/SUMMARY_TABLE_DATA";
export const PROCESSED_TABLE_DATA = "boilerplate/ImsReco/View/PROCESSED_TABLE_DATA";
export const DELETED_TABLE_DATA = "boilerplate/ImsReco/View/DELETED_TABLE_DATA";
export const TOTAL_PAGES_PROCESSED = "boilerplate/ImsReco/View/TOTAL_PAGES_PROCESSED";
export const TOTAL_PAGES_DELETED = "boilerplate/ImsReco/View/TOTAL_PAGES_DELETED";
export const DOC_LEVEL_DATA = "boilerplate/ImsReco/View/DOC_LEVEL_DATA";
export const RESET_VIEW_DATA = "boilerplate/ImsReco/View/RESET_VIEW_DATA";

export const headerColumns = [
  { value: "Summary", id: "1" },
  { value: "Processed Data", id: "2" },
  { value: "Deleted", id: "3" },
];

export const docStatus = [
  { label: "O", value: "O" },
  { label: "R", value: "R" },
];

export const recoStatus = [
  { label: "Matched", value: "Matched" },
  { label: "Mismatched", value: "Mismatched" },
  { label: "Not in GTP", value: "Not in GTP" },
  { label: "Not in GSTN", value: "Not in GSTN" },
];
